import "../../assets/style/main.css";
import "./style.scss"
import { useEffect, useRef, useState } from "react";
import $ from 'jquery'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)
import { EncryptedOBJ, DecryptedOBJ, EncryptedText, DecryptedText } from "../../utils/Encryption";
import moment from "moment";
import { Base_API } from "../../_actions/matcher";
import PageLoader from "../../components/PageLoader";
import { isPageLoading } from "../../components/PageLoader";
import SignIn_Navbar from "../../components/SignIn_Navbar";
import ARROW_DOWN_ICON from '../../assets/images/icons/arrow-b.png'
import Breadcrumb_Step from "../../components/Breadcrumb_Step";
import { getProvince, getDistrict, getSubdistrict, getPostalcode } from '../../_actions/kyc.authen';
import { JWTAuthen } from '../../_actions/sso.authen'
import ContentLoader, {isContentLoading} from "../../components/ContentLoader";

export default function KYC_Step_2() {
    let onceMount = useRef(true);
    const DOB_DAY = useRef(null);
    const DOB_MONTH = useRef(null);
    const DOB_YEAR = useRef(null);
    const INPUT_CARD_ID = useRef(null);
    const INPUT_FULLNAME_EN = useRef(null);
    const INPUT_AGE = useRef(null);
    const INPUT_CUR_ADDRESS = useRef(null);

    const DOB_PROVINCE = useRef(null);
    const DD_CUR_DISTRICT = useRef(null);
    const DD_CUR_SUBDISTRICT = useRef(null);
    const DD_CUR_POSTALCODE = useRef(null);
    const INPUT_CONTACT_ADRESS = useRef(null);
    const DD_CONTACT_PROVINCE = useRef(null);
    const DD_CONTACT_DISTRICT = useRef(null);
    const DD_CONTACT_SUBDISTRICT = useRef(null);
    const DD_CONTACT_POSTALCODE = useRef(null);

    useEffect(() => {
        if (onceMount.current) {
            pageInit();
            onceMount.current = false;
        }
    }, []);

    const [typeRegis, setTypeRegis] = useState(true); // true = idcard | false = passport
    const [ddMonth, setDDmonth] = useState([
        {
            id: 1,
            nameTH: "มกราคม",
            nameEN: "Jan",
        },
        {
            id: 2,
            nameTH: "กุมภาพันธ์",
            nameEN: "Feb",
        },
        {
            id: 3,
            nameTH: "มีนาคม",
            nameEN: "Mar",
        },
        {
            id: 4,
            nameTH: "เมษายน",
            nameEN: "Apr",
        },
        {
            id: 5,
            nameTH: "พฤษภาคม",
            nameEN: "May",
        },
        {
            id: 6,
            nameTH: "มิถุนายน",
            nameEN: "Jun",
        },
        {
            id: 7,
            nameTH: "กรกฎาคม",
            nameEN: "Jul",
        },
        {
            id: 8,
            nameTH: "สิงหาคม",
            nameEN: "Aug",
        },
        {
            id: 9,
            nameTH: "กันยายน",
            nameEN: "Sept",
        },
        {
            id: 10,
            nameTH: "ตุลาคม",
            nameEN: "Oct",
        },
        {
            id: 11,
            nameTH: "พฤศจิกายน",
            nameEN: "Nov",
        },
        {
            id: 12,
            nameTH: "ธันวาคม",
            nameEN: "Dec",
        },
    ]);
    const [ddDays, setDDdays] = useState([]);
    const [ddYears, setDDyears] = useState([]);
    const [ddGender, setDDgender] = useState([
        {
            id: 1,
            nameTH: "ชาย",
            nameEN: "male",
        },
        {
            id: 2,
            nameTH: "หญิง",
            nameEN: "female",
        },
        // { id: 3,
        //     nameTH: "อื่นๆ",
        //     nameEN: "other",
        // },
    ]);
    const [formData, setFormData] = useState({
        card_id: "",
        passport: "",
        fullname_th: "",
        fullname_en: "",
        dob: "",
        gender: "",
        age: 0,
        phone: "",
        email: "",
    });
    const [lockInputCardID, setLockInputCardID] = useState(false);
    // const [isOpen, setIsOpen] = useState(false);
    const [errorMsg, setErrorMsg] = useState({
        idcard: "",
        passport: "",
        fullname_th: "",
        fullname_en: "",
        gender: "",
        age: "",
        tel: "",
        email: ""
    });

    // const [cardData, setCardData] = useState({});

    const [itemProvince, setItemProvince] = useState([]);
    const [itemDistrict, setItemDistrict] = useState([]);
    const [itemSubdistrict, setItemSubdistrict] = useState([]);
    const [itemPostalcode, setItemPostalcode] = useState([]);
    const [itemProvinceContact, setItemProvinceContact] = useState([]);
    const [itemDistrictContact, setItemDistrictContact] = useState([]);
    const [itemSubdistrictContact, setItemSubdistrictContact] = useState([]);
    const [itemPostalcodeContact, setItemPostalcodeContact] = useState([]);

    const [address_idcard, setAddressIdcard] = useState('');
    const [provinceValue, setProvinceValue] = useState('');
    const [districtValue, setDistrictValue] = useState('');
    const [subdistrictValue, setSubdistrictValue] = useState('');
    const [postalcodeValue, setPostalcodeValue] = useState('');
    const [checkboxValue, setCheckboxValue] = useState(false);
    const [address_idcardContact, setAddressIdcardContact] = useState('');
    const [provinceValueContact, setProvinceValueContact] = useState('');
    const [districtValueContact, setDistrictValueContact] = useState('');
    const [subdistrictValueContact, setSubdistrictValueContact] = useState('');
    const [postalcodeValueContact, setPostalcodeValueContact] = useState('');


    const pageInit = async () => {
        await dropdownInit();
        await addressInit();
        checkCurrentURL();
        // idcardInfoInit();
        // await signinPhone();
        // await signinEmail();

        // let dataStep1 = !!localStorage.getItem('ETLJ06BcvUehXI/W9M0wXProzhwAGUlUW8IuHG+u8Yw=') ? DecryptedOBJ(localStorage.getItem('ETLJ06BcvUehXI/W9M0wXProzhwAGUlUW8IuHG+u8Yw=')) : null;
        // console.log(dataStep1);
        // setCardData(dataStep1)

        let lang = localStorage.getItem('Lang');
        let jwt = await JWTAuthen();

        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
        let udid = lineProfile.user_id;

        let headers = {
            token: jwt.token,
            userRef: udid,
            authorizeRef: jwt.authorizeRef,
            channalRef: jwt.channalRef
        }

        let itemGetProvince = await getProvince('th', headers);
        setItemProvince(itemGetProvince);
        setItemProvinceContact(itemGetProvince);


        isPageLoading(false);
    };

    const addressInit = () => {
        return new Promise(async resolve => {
            let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null; 
            console.log('patientData: ', patientData);
            let currentAddress = patientData.data.current_address;
            let contactAddress = patientData.data.contact_address;

            // current address
            if(!!currentAddress.address)
            {
                $(document).ready(function() {
                    let checkElem = setInterval(async() => {
                        if($('#address_idcard, #dd-province, #dd-district, #dd-subdistrict, #dd-postalcode').length >= 5)
                        {
                            clearInterval(checkElem);
                            await ConnectDistrict('th', currentAddress.province)
                            await ConnectSubdistrict('th', currentAddress.district)
                            await ConnectPostalcode('th', currentAddress.subdistrict)
            
                            $('#address_idcard').ready(function() {
                                $(INPUT_CUR_ADDRESS.current).val(currentAddress.address)
                                setAddressIdcard(currentAddress.address);
                        
                                $(DOB_PROVINCE.current).prop('value', currentAddress.province);
                                setProvinceValue(currentAddress.province);
                        
                                $(DD_CUR_DISTRICT.current).prop('value', currentAddress.district);
                                setDistrictValue(currentAddress.district);
                        
                                $(DD_CUR_SUBDISTRICT.current).prop('value', currentAddress.subdistrict);
                                setSubdistrictValue(currentAddress.subdistrict);
            
                        
                                $(DD_CUR_POSTALCODE.current).prop('value', currentAddress.postalcode);
                                setPostalcodeValue(currentAddress.postalcode);
                            })
                        }
                    }, 500)
                })
            }

            // contact address
            if(!!contactAddress.address)
            {
                setCheckboxValue(true)
                $(document).ready(async function() {
                    let checkElem = setInterval(async() => {
                        if($('.contact-address-wrap, #address_contact, #province_contact, #district_contact, #subdistrict_contact, #postalcode_contact').length >= 6)
                        {
                            clearInterval(checkElem);
                            await ConnectDistrictContact('th', contactAddress.province)
                            await ConnectSubdistrictContact('th', contactAddress.district)
                            await ConnectPostalcodeContact('th', contactAddress.subdistrict)
                            
            
                            $(INPUT_CONTACT_ADRESS.current).val(contactAddress.address)
                            setAddressIdcardContact(contactAddress.address);
                    
                            $(DD_CONTACT_PROVINCE.current).prop('value', contactAddress.province);
                            setProvinceValueContact(contactAddress.province);
                    
                            $(DD_CONTACT_DISTRICT.current).prop('value', contactAddress.district);
                            setDistrictValueContact(contactAddress.district);
                    
                            $(DD_CONTACT_SUBDISTRICT.current).prop('value', contactAddress.subdistrict);
                            setSubdistrictValueContact(contactAddress.subdistrict);
                    
                            $(DD_CONTACT_POSTALCODE.current).prop('value', contactAddress.postalcode);
                            setPostalcodeValueContact(contactAddress.postalcode);
                        }
                    }, 500)
                })
            }
            resolve()
        })
    } 

    const checkCurrentURL = () => {
        let pathname = location.pathname;
        localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
        localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));
    }

    const idcardInfoInit = () => {
        let dataEncName = process.env.REACT_APP_ENC_NAME_CAPTURE_IDCARD;
        let dataEnc = localStorage.getItem(dataEncName);
        console.log('Data Enc: ', dataEnc);
        if (!!dataEnc) {
            let dataDecrypted = DecryptedOBJ(dataEnc);
            console.log('Data Dec: ', dataDecrypted);
            let dob = String(dataDecrypted.dob).split('-');
            let day = Number(dob[0])
            let month = Number(dob[1]);
            let year = Number(dob[2])
            let currentAge = calculateAge(String(day), String(month), String(year));
            let formatCardID = formatNationalID(String(dataDecrypted.card_id))


            console.log('Card Info: ', dataDecrypted);

            $(DOB_YEAR.current).prop('value', year);
            $(DOB_MONTH.current).prop('value', month);
            $(DOB_DAY.current).prop('value', day);
            INPUT_CARD_ID.current.value = formatCardID;
            INPUT_FULLNAME_EN.current.value = dataDecrypted.full_name;
            INPUT_AGE.current.value = currentAge;

            setFormData({ ...formData, card_id: formatCardID })

            // setLockInputCardID(true);
        }
    }


    function dropdownInit() {
        return new Promise(async resolve => {
            let monthNumber = new Date().getMonth() + 1;
            let days = getDaysInMonth(1);
            let daysList = getDaysList(days);
            let yearList = getYearList();
            let currentAge = calculateAge(daysList[0], 1, yearList[0]);

            setDDdays(daysList);
            setDDyears(yearList);

            // Citizent ID (Input Init)
            let type_regis = DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS));
            console.log('type register: ', type_regis);
            if (type_regis === 'idcard') {
                setTypeRegis(true);
            } else {
                setTypeRegis(false);
            }

            resolve();
        })
    }

    function getDaysInMonth(monthId) {
        // Create a new Date object for the specified month
        const date = new Date(2023, monthId, 0);

        // Get the number of days in the month
        const daysInMonth = date.getDate();

        return daysInMonth;
    }
    const getDaysList = (days) => {
        let daysList = new Array();
        for (let i = 1; i <= days; i++) {
            daysList.push(i);

            if (Number(i) === days) {
                return daysList;
            }
        }
    };
    const getYearList = () => {
        let yearList = new Array();
        let year = new Date().getFullYear();
        let minYear = year - 100;

        for (let i = minYear; i <= year; i++) {
            yearList.push(i);

            if (Number(i) === year) {
                yearList = yearList.sort(function (a, b) {
                    return b - a;
                }); // ASC มากไปน้อย
                return yearList;
            }
        }
    };
    function calculateAge(day, month, year) {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // Months are zero-based
        const currentDay = currentDate.getDate();

        let age = currentYear - year;

        // Check if the current date (month and day) is before the birthdate
        if (currentMonth < month || (currentMonth === month && currentDay < day)) {
            age--;
        }

        return age < 0 ? 0 : age; // Don't Return Value = 0
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        // console.log(name);
        // console.log(value);

        if (name === 'address_idcard') {
            setAddressIdcard(value);
        }
        else if (name === 'province') {
            setProvinceValue(value);
            ConnectDistrict('th', value)
        } else if (name === 'district') {
            setDistrictValue(value);
            ConnectSubdistrict('th', value)
        } else if (name === 'subdistrict') {
            setSubdistrictValue(value);
            ConnectPostalcode('th', value)
        }
        else if (name === 'postalcode') {
            setPostalcodeValue(value);
        } else if (name === 'checkbox') {
            setCheckboxValue(!checkboxValue);

        } else if (name === 'address_contact') {
            setAddressIdcardContact(value);
        }
        else if (name === 'province_contact') {
            setProvinceValueContact(value);
            ConnectDistrictContact('th', value)
        } else if (name === 'district_contact') {
            setDistrictValueContact(value);
            ConnectSubdistrictContact('th', value)
        } else if (name === 'subdistrict_contact') {
            setSubdistrictValueContact(value);
            ConnectPostalcodeContact('th', value)
        }
        else if (name === 'postalcode_contact') {
            setPostalcodeValueContact(value);
        }
    };

    const ConnectDistrict = async (lang, coderef) => {
        isContentLoading(true);
        const data = await getDistrict(lang, coderef);

        setItemDistrict(data);
        isContentLoading(false);
    }

    const ConnectDistrictContact = async (lang, coderef) => {
        isContentLoading(true);
        const data = await getDistrict(lang, coderef);
        setItemDistrictContact(data);
        isContentLoading(false);
    }

    const ConnectSubdistrict = async (lang, coderef) => {
        isContentLoading(true);
        const dataSub = await getSubdistrict(lang, coderef);

        setItemSubdistrict(dataSub);
        isContentLoading(false);
    }

    const ConnectSubdistrictContact = async (lang, coderef) => {
        isContentLoading(true);
        const dataSub = await getSubdistrict(lang, coderef);

        setItemSubdistrictContact(dataSub);
        isContentLoading(false);
    }

    const ConnectPostalcode = async (lang, coderef) => {
        isContentLoading(true);
        const dataPostal = await getPostalcode(lang, coderef);

        setItemPostalcode(dataPostal);
        isContentLoading(false);
    }

    const ConnectPostalcodeContact = async (lang, coderef) => {
        isContentLoading(true);
        const dataPostal = await getPostalcode(lang, coderef);

        setItemPostalcodeContact(dataPostal);
        isContentLoading(false);
    }

    const onSubmit = async (e) => {
        e.preventDefault();

        // Form Validation
        if (formValidation()) {
            await getFormData().then(() => {
                onSkip();
            });
        }
    };

    const getFormData = async () => {
        return new Promise(async (resolve, reject) => {

            let address_Current = address_idcard;
            let province_Current = provinceValue;
            let district_Current = districtValue;
            let subdistrict_Current = subdistrictValue;
            let postalcode_Current = postalcodeValue;
            let status_Current = `${checkboxValue}`;
            let address_Contact = address_idcardContact;
            let province_Contact = provinceValueContact;
            let district_Contact = districtValueContact;
            let subdistrict_Contact = subdistrictValueContact;
            let postalcode_Contact = postalcodeValueContact;

            let updateKycPayload = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD)) : null;
            if (!!updateKycPayload) {
                if (checkboxValue === true) {
                    let occForm = {
                        ...updateKycPayload,
                        address: {
                            address_Current,
                            province_Current,
                            district_Current,
                            subdistrict_Current,
                            postalcode_Current,
                            status_Current,
                        },
                        contact_Address: {
                            address_Contact,
                            province_Contact,
                            district_Contact,
                            subdistrict_Contact,
                            postalcode_Contact
                        }
                    }
                    console.log(occForm);
                    let enc_regis_info = EncryptedOBJ(occForm);
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD, enc_regis_info);
                } else {
                    let occForm = {
                        ...updateKycPayload,
                        address: {
                            address_Current,
                            province_Current,
                            district_Current,
                            subdistrict_Current,
                            postalcode_Current,
                            status_Current,
                        },
                        contact_Address: {
                            address_Contact,
                            province_Contact,
                            district_Contact,
                            subdistrict_Contact,
                            postalcode_Contact
                        },
                    }
                    console.log(occForm);
                    let enc_regis_info = EncryptedOBJ(occForm);
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD, enc_regis_info);
                }
            }

            resolve();
        });

    }


    const formValidation = () => {

        let errors = {};
        let formIsValid = true;

        if (!address_idcard || address_idcard.length <= 0) {
            errors["address"] = "*กรุณากรอกที่อยู่";
            formIsValid = false;
        }

        if (!provinceValue || provinceValue.length <= 0) {
            errors["province_Error"] = "*กรุณาเลือกจังหวัด";
            formIsValid = false;
        }
        console.log('address_idcardContact: ', address_idcardContact);
        if (checkboxValue === true) {
            if (!address_idcardContact || address_idcardContact.length <= 0) {
                errors["address_con_err"] = "*กรุณากรอกที่อยู่";
                formIsValid = false;
            }

            if (!provinceValueContact || provinceValue.lengthContact <= 0) {
                errors["province_con_Error"] = "*กรุณาเลือกจังหวัด";
                formIsValid = false;
            }
        }



        setErrorMsg(errors);
        return formIsValid;
    }

    function isValidPassportFormat(passportNumber) {
        // Remove all non-alphanumeric characters from the passport number
        const cleanedPassportNumber = passportNumber.replace(/[^a-zA-Z0-9]/g, '');

        // Check if the cleaned passport number matches the format
        const validFormat = /^[A-Z]{1,2}\d{6,7}$/.test(cleanedPassportNumber);

        return validFormat;
    }

    const nextPage = () => {
        window.location.href = `/Register/PrivacyPolicy`
    };

    const isValidEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    };

    const handleChangePassport = (e) => {
        let name = e.target.name;
        let value = String(e.target.value).replace(/[^a-zA-Z0-9]/g, '');
        let formatValue = formatPassportNumber(value);

        if (!!value && isValidPassportFormat(formatValue)) {
            setErrorMsg({
                ...errorMsg, passport: ''
            })
        } else {
            setErrorMsg({
                ...errorMsg, passport: '*กรุณากรอกพาสปอร์ตให้ครบถ้วน'
            })
        }

        setFormData({ ...formData, passport: formatValue });
    }

    function formatPassportNumber(passportNumber) {
        // Remove all non-alphanumeric characters from the passport number
        const cleanedPassportNumber = passportNumber.replace(/[^a-zA-Z0-9]/g, '');

        // Convert letters to uppercase
        const uppercasePassportNumber = cleanedPassportNumber.toUpperCase();

        // Split the cleaned passport number into parts: letters and numbers
        const letters = uppercasePassportNumber.match(/[a-zA-Z]+/);
        const numbers = uppercasePassportNumber.match(/\d+/);

        // Check if both letters and numbers parts are present
        if (letters && numbers) {
            // Create the formatted passport number
            const formattedPassportNumber = `(${letters[0]}) ${numbers[0]}`;
            return formattedPassportNumber;
        } else {
            // Return the original cleaned passport number if formatting is not possible
            return uppercasePassportNumber;
        }
    }

    const onlyInputNumber = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        const numericValue = value.replace(/\D/g, '');

        if (name === "card_id") {
            const isNumber = /^[\d-]*$/.test(value);
            if (isNumber) {
                if (numericValue.length <= 13) {
                    let formatValue = formatNationalID(numericValue);
                    setFormData({ ...formData, card_id: formatValue });
                }
            }

            // Handle Error
            if (!numericValue || numericValue.length < 13) {
                // กรุณากรอกเลขประจำตัวประชาชนให้ครบถ้วน
                setErrorMsg({ ...errorMsg, idcard: "*กรุณากรอกเลขประจำตัวประชาชนให้ครบถ้วน" });
            } else {
                setErrorMsg({ ...errorMsg, idcard: "" });
            }
        }
        if (name === "tel") {
            const isPhoneNumberValid = /^[\d()\s-]*$/.test(value);
            const cleanedValue = value.replace(/\D/g, '');
            if (isPhoneNumberValid) {
                if (cleanedValue.length === 10) {
                    let formatValue = formatThaiPhoneNumber(cleanedValue);
                    setFormData({ ...formData, phone: formatValue });
                } else {
                    setFormData({ ...formData, phone: cleanedValue });
                }
            }

            if (!cleanedValue || cleanedValue.length < 10) {
                // กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน
                setErrorMsg({ ...errorMsg, tel: "*กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน" });
            } else {
                setErrorMsg({ ...errorMsg, tel: "" });
            }
        }
    }

    const formatThaiPhoneNumber = (value) => {
        const numericValue = value.replace(/\D/g, '');
        let formattedValue = numericValue;

        if (numericValue.length > 3) {
            formattedValue = numericValue.replace(/^(\d{3,3})(\d{0,3})(\d{0,4})$/, '($1) $2-$3');
        }

        return formattedValue;
    };

    const formatNationalID = (value) => {
        const numericValue = value.replace(/\D/g, '');
        const formattedValue = numericValue.replace(/^(\d{1,1})(\d{4,4})(\d{5,5})(\d{2,2})(\d{1,1})$/, '$1-$2-$3-$4-$5');
        return formattedValue;
    };

    const checkValidInput = (e) => {
        let name = e.target.name;
        let value = e.target.value

        if (name === "fname_th") {
            let full_name_th_split = value.split(' ');
            let first_name_th = full_name_th_split[0];
            let last_name_th = full_name_th_split.length > 1 ? full_name_th_split[full_name_th_split.length - 1] : "";

            if (!value || value.length <= 0 || !first_name_th || first_name_th.length <= 0 || !last_name_th || last_name_th.length <= 0) {
                // กรุณากรอก ชื่อ นามสกุล ภาษาไทย ให้ครบถ้วน
                setErrorMsg({ ...errorMsg, fullname_th: "*กรุณากรอก ชื่อ-นามสกุล ภาษาไทยให้ครบถ้วน" })
            } else {
                if (!containsThaiCharacters(value)) {
                    // กรุณากรอกชื่อภาษาไทย
                    setErrorMsg({ ...errorMsg, fullname_th: "*กรุณากรอกชื่อภาษาไทย" })
                } else {
                    setErrorMsg({ ...errorMsg, fullname_th: "" })
                }
            }
        }
        if (name === 'fname_en') {
            let full_name_en_split = value.split(' ');
            let first_name_en = full_name_en_split[0];
            let last_name_en = full_name_en_split.length > 1 ? full_name_en_split[full_name_en_split.length - 1] : "";

            if (!value || value.length <= 0 || !first_name_en || first_name_en.length <= 0 || !last_name_en || last_name_en.length <= 0) {
                // กรุณากรอก ชื่อ นามสกุล ภาษาไทย ให้ครบถ้วน
                setErrorMsg({ ...errorMsg, fullname_en: "*กรุณากรอก ชื่อ-นามสกุล ภาษาอังกฤษให้ครบถ้วน" })
            } else {
                if (!containsEnglishCharacters(value)) {
                    // กรุณากรอกชื่อภาษาไทย
                    setErrorMsg({ ...errorMsg, fullname_en: "*กรุณากรอกชื่อภาษาอังกฤษ" })
                } else {
                    setErrorMsg({ ...errorMsg, fullname_en: "" })
                }
            }
        }
        if (name === "gender") {
            if (!value || value === 'default') {
                setErrorMsg({ ...errorMsg, gender: "*กรุณาระบุเพศ" })
            } else {
                setErrorMsg({ ...errorMsg, gender: "" })
            }
        }
        if (name === "email") {
            if (!!value && value.length > 0) {
                // checking email
                if (!isValidEmail(value)) {
                    // กรุณากรอกอีเมลให้ถูกต้อง
                    setErrorMsg({ ...errorMsg, email: "*กรุณากรอกอีเมลให้ถูกต้อง" })
                } else {
                    setErrorMsg({ ...errorMsg, email: "" })
                }
            } else {
                setErrorMsg({ ...errorMsg, email: "" })
            }
        }
    }

    function containsEnglishCharacters(input) {
        const englishPattern = /[A-Za-z]/; // English letters
        return englishPattern.test(input);
    }
    function containsThaiCharacters(input) {
        const thaiPattern = /[\u0E00-\u0E7F]/; // Thai Unicode range
        return thaiPattern.test(input);
    }

    const openAlert = (title, body, button) => {
        let alertConfirmElem = (
            <div className="swal-cfpm">
                <div className="top">
                    <img onClick={handleCloseAlert} src="/images/icons/close-btn-2.png" />
                </div>

                <div className="mid">
                    <h2 className="title">{title}</h2>
                    <p className="desc">
                        {body}
                    </p>
                </div>

                <div className={`bottom`}>
                    <button type="button" onClick={handleCloseAlert}>
                        {button}
                    </button>
                </div>
            </div>
        );

        MySwal.fire({
            html: alertConfirmElem,
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
        });

    };

    const handleCloseAlert = () => {
        MySwal.close();
    };

    const onSkip = () => {


        location.href = `${Base_API.pathWeb}/n-health/kyc/step-3`;
    }

    return (
        <>
            <div className="kyc-step-2-con container-profile">
                <PageLoader />
                <SignIn_Navbar canClose={false} />
                <Breadcrumb_Step step={2} />

                <h3 className="header-text">
                    ข้อมูลที่อยู่
                </h3>

                <form action="#" onSubmit={onSubmit} className="form-wrap">
                    <div className="form-group" name="fname">
                        <label htmlFor="address_idcard" className="text-bold">ที่อยู่บัตรประชาชน</label>
                        <label htmlFor="address_idcard">ที่อยู่</label>
                        <textarea
                            id="address_idcard"
                            name="address_idcard"
                            placeholder="บ้านเลขที่, หมู่บ้าน, ซอย, หมู่"
                            ref={INPUT_CUR_ADDRESS}
                            onChange={handleChange}
                        >
                        </textarea>
                        <p className="input-error">
                            {errorMsg["address"]}
                        </p>
                    </div>
                    <div className="form-group" name="fname">
                        <label htmlFor="fname">จังหวัด</label>
                        <div className="form-select">
                            <select id="dd-province" defaultValue={0} name="province" onChange={handleChange} ref={DOB_PROVINCE}>
                                <option disabled selected>กรุณาเลือกจังหวัด</option>
                                {itemProvince.map((item) => (
                                    <option value={item.coderef} key={item.coderef}>
                                        {item.titledata}
                                    </option>
                                ))}
                            </select>
                            <img
                                src={ARROW_DOWN_ICON}
                                className="arrow"
                            />
                        </div>
                        <p className="input-error">
                            {errorMsg["province_Error"]}
                        </p>
                    </div>
                    <div className="form-group" name="fname">
                        <label htmlFor="fname">เขต/อำเภอ</label>
                        <div className="form-select">
                            <select id="dd-district" disabled={itemDistrict.length === 0} defaultValue={1} name="district" onChange={handleChange} ref={DD_CUR_DISTRICT}>
                                <option disabled selected>เลือก</option>
                                {
                                    itemDistrict.length > 0 && (
                                        itemDistrict.map((item) => (
                                            <option value={item.coderef} key={item.coderef}>
                                                {item.titledata}
                                            </option>
                                        ))
                                    )
                                }
                            </select>
                            <img
                                src={ARROW_DOWN_ICON}
                                className="arrow"
                            />
                        </div>

                    </div>
                    <div className="form-group" name="fname">
                        <label htmlFor="fname">แขวง/ตำบล</label>
                        <div className="form-select">
                            <select id="dd-subdistrict" disabled={itemSubdistrict.length === 0} defaultValue={1} name="subdistrict" onChange={handleChange} ref={DD_CUR_SUBDISTRICT}>
                                <option disabled selected>เลือก</option>
                                {
                                    itemSubdistrict.length > 0 && (
                                        itemSubdistrict.map((item) => (
                                            <option value={item.coderef} key={item.coderef}>
                                                {item.titledata}
                                            </option>
                                        ))
                                    )
                                }
                            </select>
                            <img
                                src={ARROW_DOWN_ICON}
                                className="arrow"
                            />
                        </div>
                    </div>
                    <div className="form-group" name="fname">
                        <label htmlFor="fname">รหัสไปรษณีย์</label>
                        <div className="form-select">
                            <select id="dd-postalcode" disabled={itemPostalcode.length === 0} defaultValue={1} name="postalcode" onChange={handleChange} ref={DD_CUR_POSTALCODE}>
                                <option disabled selected>เลือก</option>
                                {
                                    itemPostalcode.length > 0 && (
                                        itemPostalcode.map((item) => (
                                            <option value={item.coderef} key={item.coderef}>
                                                {item.titledata}
                                            </option>
                                        ))
                                    )
                                }
                            </select>
                            <img
                                src={ARROW_DOWN_ICON}
                                className="arrow"
                            />
                        </div>
                    </div>
                    <div className="form-group btn-conadd">
                        <label htmlFor='confirm' className="top">
                            <input type="checkbox" id="confirm" name="checkbox" value={checkboxValue} checked={checkboxValue} onChange={handleChange} />
                            <label htmlFor='confirm'>ที่อยู่ที่สะดวกในการติดต่อ <br /> แตกต่างจากที่อยู่ตามบัตรประชาชน</label>
                        </label>
                    </div>

                    {
                        checkboxValue && (
                            <div className="contact-address-wrap">
                                <div className="form-group" name="fname">
                                    <label htmlFor="address_contact" className="text-bold">ที่อยู่ติดต่อ</label>
                                    <label htmlFor="address_contact">ที่อยู่</label>
                                    <textarea
                                        id="address_contact"
                                        name="address_contact"
                                        placeholder="บ้านเลขที่, หมู่บ้าน, ซอย, หมู่"
                                        onChange={handleChange}
                                        ref={INPUT_CONTACT_ADRESS}
                                    >
                                    </textarea>
                                    <p className="input-error">
                                        {errorMsg["address_con_err"]}
                                    </p>
                                </div>
                                <div className="form-group" name="fname">
                                    <label htmlFor="fname">จังหวัด</label>
                                    <div className="form-select">
                                        <select id="province_contact" name="province_contact" onChange={handleChange} ref={DD_CONTACT_PROVINCE}>
                                            <option disabled selected>กรุณาเลือกจังหวัด</option>
                                            {itemProvinceContact.map((item) => (
                                                <option value={item.coderef} key={item.coderef}>
                                                    {item.titledata}
                                                </option>
                                            ))}
                                        </select>
                                        <img
                                            src={ARROW_DOWN_ICON}
                                            className="arrow"
                                        />
                                    </div>
                                    <p className="input-error">
                                        {errorMsg["province_con_Error"]}
                                    </p>
                                </div>
                                <div className="form-group" name="fname">
                                    <label htmlFor="fname">เขต/อำเภอ</label>
                                    <div className="form-select">
                                        <select id="district_contact" disabled={itemDistrictContact.length === 0} defaultValue={1} name="district_contact" onChange={handleChange} ref={DD_CONTACT_DISTRICT}>
                                            <option disabled selected>เลือก</option>
                                            {
                                                itemDistrictContact.length > 0 && (
                                                    itemDistrictContact.map((item) => (
                                                        <option value={item.coderef} key={item.coderef}>
                                                            {item.titledata}
                                                        </option>
                                                    ))
                                                )
                                            }
                                        </select>
                                        <img
                                            src={ARROW_DOWN_ICON}
                                            className="arrow"
                                        />
                                    </div>

                                </div>
                                <div className="form-group" name="fname">
                                    <label htmlFor="fname">แขวง/ตำบล</label>
                                    <div className="form-select">
                                        <select id="subdistrict_contact" disabled={itemSubdistrictContact.length === 0} defaultValue={1} name="subdistrict_contact" onChange={handleChange} ref={DD_CONTACT_SUBDISTRICT}>
                                            <option disabled selected>เลือก</option>
                                            {
                                                itemSubdistrictContact.length > 0 && (
                                                    itemSubdistrictContact.map((item) => (
                                                        <option value={item.coderef} key={item.coderef}>
                                                            {item.titledata}
                                                        </option>
                                                    ))
                                                )
                                            }
                                        </select>
                                        <img
                                            src={ARROW_DOWN_ICON}
                                            className="arrow"
                                        />
                                    </div>
                                </div>
                                <div className="form-group" name="fname">
                                    <label htmlFor="fname">รหัสไปรษณีย์</label>
                                    <div className="form-select">
                                        <select id="postalcode_contact" disabled={itemPostalcodeContact.length === 0} defaultValue={1} name="postalcode_contact" onChange={handleChange} ref={DD_CONTACT_POSTALCODE}>
                                            <option disabled selected>เลือก</option>
                                            {
                                                itemPostalcodeContact.length > 0 && (
                                                    itemPostalcodeContact.map((item) => (
                                                        <option value={item.coderef} key={item.coderef}>
                                                            {item.titledata}
                                                        </option>
                                                    ))
                                                )
                                            }
                                        </select>
                                        <img
                                            src={ARROW_DOWN_ICON}
                                            className="arrow"
                                        />
                                    </div>
                                </div>
                            </div>
                        )
                    }


                    {/* <button 
                        className={`btn-save`} type="button" 
                        // onClick={onSubmit}
                        onClick={onSkip}
                    >
                        บันทึกข้อมูล
                    </button> */}
                    <button
                        className={`btn-submit`} type="submit"
                        onClick={onSubmit}
                    // onClick={onSkip}
                    >
                        ดำเนินการต่อ
                    </button>
                </form>
                {/* <PrivacyPolicy /> */}
            </div>
            <ContentLoader/>
        </>
    );
}
